// Baselayer Results Explorer — Exclusion list tab. Shows "No Exclusions Found"
// or a list of exclusion hits read defensively off the KYB rawResponseJson.

import {
  Table,
  THead,
  TBody,
  TR,
  TH,
  TD,
  EmptyState,
} from "@/design-system/components/ui";
import { formatLooseDate } from "../tabHelpers";
import {
  asArray,
  asObject,
  asString,
  pick,
  type ParsedKyb,
} from "../parse";

export function ExclusionListTab({ kyb }: { kyb: ParsedKyb }) {
  const raw = asArray(
    pick(kyb.raw, "exclusions", "exclusion_list", "exclusion_hits") ??
      pick(kyb.business, "exclusions"),
  );

  const exclusions = raw.map((e) => {
    const o = asObject(e);
    return {
      name: asString(pick(o, "name", "entity_name", "party")) ?? "—",
      list: asString(pick(o, "list", "source", "program")) ?? "—",
      date: asString(pick(o, "date", "excluded_date", "effective_date")),
      reason: asString(pick(o, "reason", "remarks", "description")) ?? "—",
    };
  });

  if (exclusions.length === 0) {
    return (
      <EmptyState
        title="No Exclusions Found"
        description="This subject does not appear on any exclusion list."
      />
    );
  }

  return (
    <Table>
      <THead>
        <TR>
          <TH>Name</TH>
          <TH>List</TH>
          <TH>Date</TH>
          <TH>Reason</TH>
        </TR>
      </THead>
      <TBody>
        {exclusions.map((e, i) => (
          <TR key={`${e.name}-${i}`}>
            <TD>{e.name}</TD>
            <TD>{e.list}</TD>
            <TD>{formatLooseDate(e.date)}</TD>
            <TD>{e.reason}</TD>
          </TR>
        ))}
      </TBody>
    </Table>
  );
}
